export default __webpack_public_path__ + "8a86d20c80628a7015a93a1430bbd9c3.png";